import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface SitemapPreviewParams {
	sitemap: string;
	contentSelector?: string;
	titleSelector?: string;
	postImageSelector?: string;
	postContentSelector?: string;
	locationPrefix?: string;
	PageLimit?: number;
	impersonationContext?: Api.IImpersonationContext;
}

export function useBlogSitemapPreviewMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (rssXml: string) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async (params: SitemapPreviewParams) => {
			const { impersonationContext, ...queryParams } = params;
			const queryString = new URLSearchParams(
				Object.entries(queryParams).reduce(
					(acc, [key, value]) => {
						if (value !== undefined && value !== null && value !== '') {
							acc[key] = String(value);
						}
						return acc;
					},
					{} as Record<string, string>
				)
			).toString();

			return new Promise<string>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceRawResponse(
					Api.ImpersonationBroker.composeApiUrl({
						impersonationContext,
						urlPath: `blog/previewSitemapImport?${queryString}`,
					}),
					'POST',
					null,
					async (response: Response) => {
						if (!response.ok) {
							reject(new Error(`Failed to preview sitemap: ${response.statusText}`));
							return;
						}
						const rssText = await response.text();
						resolve(rssText);
					},
					error => {
						reject(error);
					}
				);
			});
		},
		onError,
		onSuccess,
	});
}
